import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import EventList from './components/EventList';
import EventDetail from './components/EventDetail';
import Header from './components/Header';
import AdminDashboard from './components/AdminDashboard';
import TicketValidator from './components/TicketValidator';
import EventManager from './components/EventManager';
import TicketPurchase from './components/TicketPurchase';
import CheckoutSuccess from './components/CheckoutSuccess';
import CheckoutFailed from './components/CheckoutFailed';
import StripeTestComponent from './components/StripeTestComponent';
import Demo from './components/Demo';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { useParams } from 'react-router-dom';
import './App.css';
import './styles/theme.css';

// Loading component for Suspense
const SuspenseLoader = () => (
  <div className="suspense-loader">
    <div className="loading-spinner"></div>
    <p>Loading...</p>
  </div>
);

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <div className="App">
            <Header />
            <main className="main-content">
              <Suspense fallback={<SuspenseLoader />}>
                <Routes>
                  <Route path="/" element={<Demo />} />
                  <Route path="/events" element={<EventList />} />
                  <Route path="/events/:id" element={<EventDetail />} />
                  <Route 
                    path="/admin" 
                    element={
                      <ProtectedRoute>
                        <AdminDashboard />
                      </ProtectedRoute>
                    } 
                  />
                  <Route 
                  path="/validate" 
                  element={
                    <ProtectedRoute>
                      <TicketValidator />
                    </ProtectedRoute>
                  } 
                />
                <Route 
                  path="/manager" 
                  element={
                    <ProtectedRoute>
                      <EventManager />
                    </ProtectedRoute>
                  } 
                />
                <Route path="/purchase/:eventId" element={<TicketPurchaseWrapper />} />
                <Route path="/stripe-test" element={<StripeTestComponent />} />
                <Route path="/checkout/success/:sessionId" element={<CheckoutSuccess />} />
                <Route path="/checkout/cancel" element={<CheckoutFailed />} />
                <Route path="/checkout/failed/:sessionId" element={<CheckoutFailed />} />
              </Routes>
              </Suspense>
            </main>
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

function TicketPurchaseWrapper() {
  const { eventId } = useParams<{ eventId: string }>();
  return eventId ? <TicketPurchase eventId={eventId} /> : <div>Event not found</div>;
}

export default App;
